import { createFileRoute } from '@tanstack/react-router'

/**
 * `/tasks` n'a pas de contenu propre : la liste et le kanban vivent dans le
 * layout `_app/tasks.tsx`, pour rester montés quand le panneau de détail
 * s'ouvre par-dessus.
 */
export const Route = createFileRoute('/_app/tasks/')({
  component: () => null,
})
